import DOM from './jqueryDOM';

// https://github.com/rosivanov/goodshare.js/tree/master/src/providers

function SocialShare() {
  function openWindow(url) {
    return window.open(url, '', `width=640,height=480,left=${(window.screen.width - 640) / 2},top=${(window.screen.height - 480) / 2},location=no,toolbar=no,menubar=no,scrollbars=1`);
  }

  DOM.$document.on('click', '.js-social-share', function share(e) {
    e.preventDefault();
    const $trigger = $(this);
    const social = $trigger.data('share');

    let url = $trigger.data('share-url') ? $trigger.data('share-url') : document.location.href;
    let title = $trigger.data('share-title') ? $trigger.data('share-title') : '';
    let description = $trigger.data('share-description') ? $trigger.data('share-description') : '';
    let image = $trigger.data('share-image') ? $trigger.data('share-image') : '';

    url = encodeURIComponent(url);
    title = encodeURIComponent(title);
    description = encodeURIComponent(description);
    image = encodeURIComponent(image);

    switch (social) {
      case 'vk': {
        let sharerUrl = `https://vk.com/share.php?url=${url}`;

        if (title) {
          sharerUrl += `&title=${title}`;
        }

        if (description) {
          sharerUrl += `&description=${description}`;
        }

        if (image) {
          sharerUrl += `&image=${image}`;
        }

        openWindow(sharerUrl);
        break;
      }
      case 'fb': {
        let sharerUrl = `https://facebook.com/sharer/sharer.php?u=${url}`;

        if (title) {
          sharerUrl += `&t=${title}`;
        }

        openWindow(sharerUrl);
        break;
      }
      case 'ok': {
        let sharerUrl = `https://connect.ok.ru/offer?url=${url}`;

        if (title) {
          sharerUrl += `&title=${title}`;
        }

        if (image) {
          sharerUrl += `&imageUrl=${image}`;
        }

        openWindow(sharerUrl);
        break;
      }
      case 'tw': {
        let sharerUrl = `http://twitter.com/share?url=${url}`;

        if (title) {
          sharerUrl += `&text=${title}`;
        }

        openWindow(sharerUrl);
        break;
      }
      case 'weibo': {
        let sharerUrl = `http://service.weibo.com/share/share.php?url=${url}&appkey=&pic=&ralateUid=`;

        if (title) {
            sharerUrl += `&title=${title}`;
        }

        openWindow(sharerUrl);
        break;
      }
      case 'whatsapp': {
        const sharerUrl = `https://wa.me/?text=${title}%20${url}`;
        openWindow(sharerUrl);
        break;
      }
      case 'tg': {
        let sharerUrl = `https://t.me/share/url?url=${url}`;

        if (description) {
          sharerUrl += `&text=${description}`;
        }

        openWindow(sharerUrl);
        break;
      }
      default:
        break;
    }
  });
}

export default new SocialShare();
